// src/services/authService.ts
import api from "./axios";

interface RegisterPayload {
  name: string;
  interest_ids: number[];
  email: string;
  password: string;
  confirmPassword: string;
  recaptchaToken: string;
}

interface OtpPayload {
  email: string;
  otp: string;
}

interface ForgotPasswordPayload {
  email: string;
}

interface ResetPasswordPayload {
  email: string;
  password: string;
  confirmPassword: string;
}

interface LoginPayload {
  email: string;
  password: string;
  recaptchaToken: string;
}

export const getInterests = async () => {
  return api.get("/interests");
};

export const register = async (data: RegisterPayload) => {
  return api.post("/auth/register", data);
};

export const registerVerifyOtp = async (data: OtpPayload) => {
  return api.post("/auth/verify-otp", data);
};

export const resendOtp = async (email: string) => {
  return api.post("/auth/resend-otp", { email });
};

export const forgotPassword = async (data: ForgotPasswordPayload) => {
  return api.post("/auth/forgot-password", data);
};

export const verifyForgotPasswordOtp = async (data: OtpPayload) => {
  return api.post("/auth/verify-reset-otp", data);
};

export const resetPassword = async (data: ResetPasswordPayload) => {
  return api.post("/auth/reset-password", data);
};

export const login = async (data: LoginPayload) => {
  return api.post("/auth/login", data);
};

export const logout = async () => {
  return api.post("/auth/logout");
};
